const config = {  
  basePublicGatewayUrl: process.env.REACT_APP_PUBLIC_GATEWAY_URL,
  baseApiV1Url: process.env.REACT_APP_API_V1_URL,
  clientId: process.env.REACT_APP_API_CLIENT_ID,
  userPortalUrl: process.env.REACT_APP_USER_PORTAL_URL,
  firebase: {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  },
  googleMapsKey: process.env.REACT_APP_GOOGLE_MAPS_KEY,
  env: process.env.NODE_ENV,
  segment: {
    id: process.env.REACT_APP_SEGMENT_ID,
  },
  googleAnalytics: {
    trackingId: process.env.REACT_APP_GOOGLE_ANALYTICS_TRACKING_ID,
    enabled: String(process.env.REACT_APP_GOOGLE_ANALYTICS_ENABLED).toLowerCase() === 'true'
  }
};

export default config;